import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/stores/authStore';

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import('../modules/panel-control/Dashboard.vue'),
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../modules/login/FormLogin.vue')
    },
    
    // --- RUTAS DE DIRECCIÓN ---
    {
        path: '/director/gestion',
        name: 'director-gestion',
        component: () => import('../modules/director/GestionInstitucional.vue'), // Debes crear este componente
    },
    {
        path: '/director/reportes',
        name: 'director-reportes',
        component: () => import('../modules/director/ReportesGenerales.vue'),
    },
    {
        path: '/director/estudiantes',
        name: 'director-estudiantes',
        component: () => import('../modules/director/ListaEstudiantes.vue'),
    },
    {
        path: '/director/docentes',
        name: 'director-docentes',
        component: () => import('../modules/director/ListaDocentes.vue'),
    },
    {
        path: '/director/centralizadorBR',
        name: 'director-centralizador',
        component: () => import('../modules/director/CentralizadorBR.vue'),
    },
    {
        path: '/director/centralizador-anual',
        name: 'director-centralizador-anual',
        component: () => import('../modules/director/CentralizadorCalificacionesAnual.vue'),
    },
    {
        path: '/director/mejores-estudiantes',
        name: 'director-mejores-estudiantes',
        component: () => import('../modules/director/MejoresEstudiantes.vue'),
    },
    {
        path: '/director/boletines',
        name: 'director-boletines',
        component: () => import('../modules/director/ListaCalificaciones.vue'),
    },
    {
        path: '/director/control',
        name: 'director-control',
        component: () => import('../modules/director/GestionControl.vue'),
    },

    // --- RUTAS DE SECRETARÍA ---
    {
        path: '/secretaria/inscripciones',
        name: 'secretaria-inscripciones',
        component: () => import('../modules/secretaria/Inscripciones.vue'),
    },
    {
        path: '/secretaria/declaraciones-juradas',
        name: 'secretaria-declaraciones-juradas',
        component: () => import('../modules/director/GestionDeclaraciones.vue'),
    },
    {
        path: '/publico/declaraciones',
        name: 'publico-declaraciones',
        component: () => import('../views/ConsultaPublicaPadres.vue'),
        
    },

    

    // --- RUTAS DE DOCENTE ---
    {
        path: '/docente/cursos',
        name: 'docente-cursos',
        component: () => import('../modules/docente/ListaCursos.vue'),
    },
    {
        path: '/docente/centralizadorbr',
        name: 'docente-centralizadorbr',
        component: () => import('../modules/docente/CentralizadorBR.vue'),
    },
    {
        path: '/docente/centralizador-calificaciones',
        name: 'docente-centralizador-calificaciones',
        component: () => import('../modules/docente/CentralizadorCalificaciones.vue'),
    },
    {
        path: '/docente/centralizador-calificaciones-anual',
        name: 'docente-centralizador-calificaciones-anual',
        component: () => import('../modules/docente/CentralizadorCalificacionesAnual.vue'),
    },
    {
        path: '/docente/mejores-estudiantes',
        name: 'docente-mejores-estudiantes',
        component: () => import('../modules/docente/MejoresEstudiantes.vue'),
    },
    {
        path: '/docente/pedagogico',
        name: 'docente-pedagogico',
        component: () => import('../modules/docente/RegistroPedagogico.vue'),
    },
    {
        path: '/docente/calificaciones',
        name: 'docente-calificaciones',
        component: () => import('../modules/docente/RegistroCalificaciones.vue'),
    },
    {
        path: '/docente/centralizador-trimestral',
        name: 'docente-trimestral',
        component: () => import('../modules/docente/ListaTrimestral.vue'),
    },
    {
        path: '/docente/boletin-electronico',
        name: 'boletin-electronico',
        component: () => import('../modules/docente/Boletin.vue'),
    },
     {
        path: '/usuario/perfil',
        name: 'usuario-perfil',
        component: () => import('../modules/usuario/UserProfile.vue'),
    },


    // --- RUTAS DE SISTEMA / ELECCIONES (Existentes) ---
    { path: '/dashboard', name: 'dashboard', component: () => import('../modules/panel-control/Dashboard.vue') },
    { path: '/usuarios', name: 'usuarios', component: () => import('../modules/usuario/ListaUsuarios.vue') },
    
    // Ruta para manejo de errores 404
    {
        path: '/:pathMatch(.*)*',
        name: 'notfound',
        component: () => import('../pages/NotFound.vue')
    }
];

const router = createRouter({
    history: createWebHistory(process.env.VUE_APP_BASE_URL),
    routes,
    scrollBehavior() {
        return { left: 0, top: 0 };
    }
});

/**
 * GUARDIA DE NAVEGACIÓN
 */
router.beforeEach((to, from, next) => {
    const authStore = useAuthStore();
    const publicPages = ['login', 'error', 'notfound', 'publico-declaraciones'];
    const authRequired = !publicPages.includes(to.name);
    const loggedIn = authStore.isTokenValid();

    if (authRequired && !loggedIn) {
        return next({ name: 'login' });
    }

    if (to.name === 'login' && loggedIn) {
        return next({ name: 'home' });
    }

    next();
});

export default router;